var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/promo-style-macro.j2"] = require( "macros/promo-style-macro.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["promo-simple-banner.j2"] = require( "promo-simple-banner.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/global-promo.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/promo-style-macro.j2", false, "core/templates/global-promo.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("setPromoStyle")) {
var t_4 = t_1.setPromoStyle;
} else {
cb(new Error("cannot import 'setPromoStyle'")); return;
}
context.setVariable("setPromoStyle", t_4);
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/global-promo.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("contentfulUrl")) {
var t_8 = t_5.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_8);
output += "\n\n";
var t_9;
t_9 = "";
frame.set("gaAction", t_9, true);
if(frame.topLevel) {
context.setVariable("gaAction", t_9);
}
if(frame.topLevel) {
context.addExport("gaAction", t_9);
}
output += "\n";
var t_10;
t_10 = "marketing";
frame.set("gaCategory", t_10, true);
if(frame.topLevel) {
context.setVariable("gaCategory", t_10);
}
if(frame.topLevel) {
context.addExport("gaCategory", t_10);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "promoType") == "header") {
output += "\n    ";
var t_11;
t_11 = true;
frame.set("isHeader", t_11, true);
if(frame.topLevel) {
context.setVariable("isHeader", t_11);
}
if(frame.topLevel) {
context.addExport("isHeader", t_11);
}
output += "\n    ";
var t_12;
t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"primaryHeaderPromo");
frame.set("promo", t_12, true);
if(frame.topLevel) {
context.setVariable("promo", t_12);
}
if(frame.topLevel) {
context.addExport("promo", t_12);
}
output += "\n    ";
var t_13;
t_13 = "gpc_top";
frame.set("gaAction", t_13, true);
if(frame.topLevel) {
context.setVariable("gaAction", t_13);
}
if(frame.topLevel) {
context.addExport("gaAction", t_13);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "promoType") == "header-secondary") {
output += "\n    ";
var t_14;
t_14 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"secondaryHeaderPromo");
frame.set("promo", t_14, true);
if(frame.topLevel) {
context.setVariable("promo", t_14);
}
if(frame.topLevel) {
context.addExport("promo", t_14);
}
output += "\n    ";
var t_15;
t_15 = "gpc_mid";
frame.set("gaAction", t_15, true);
if(frame.topLevel) {
context.setVariable("gaAction", t_15);
}
if(frame.topLevel) {
context.addExport("gaAction", t_15);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "promoType") == "footer") {
output += "\n    ";
var t_16;
t_16 = true;
frame.set("isFooter", t_16, true);
if(frame.topLevel) {
context.setVariable("isFooter", t_16);
}
if(frame.topLevel) {
context.addExport("isFooter", t_16);
}
output += "\n    ";
var t_17;
t_17 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"primaryFooterPromo");
frame.set("promo", t_17, true);
if(frame.topLevel) {
context.setVariable("promo", t_17);
}
if(frame.topLevel) {
context.addExport("promo", t_17);
}
output += "\n    ";
var t_18;
t_18 = "prime_footer";
frame.set("gaAction", t_18, true);
if(frame.topLevel) {
context.setVariable("gaAction", t_18);
}
if(frame.topLevel) {
context.addExport("gaAction", t_18);
}
output += "\n";
;
}
;
}
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"linkHoverColor")) {
output += "<style>\n    .s-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo a:hover,\n    .s-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo a:active {\n        color: #";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"linkHoverColor"), env.opts.autoescape);
output += ";\n    }\n</style>";
;
}
output += "<div class=\"s-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo js-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo js-global-promo\" data-qa-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo>\n\n    <div class=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteSwitchingActive")) {
output += "u-extra-small--hide";
;
}
output += "\">\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"contentType") == "globalPromoSimpleBanner") {
output += "\n\n    <div class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__simple-banner\" data-qa-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-simple-banner>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                ";
env.getTemplate("promo-simple-banner.j2", false, "core/templates/global-promo.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n\n    ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"contentType") == "globalPromoContentBanner") {
output += "\n\n    <div ";
output += runtime.suppressValue((lineno = 50, colno = 23, runtime.callWrap(t_4, "setPromoStyle", context, [runtime.contextOrFrameLookup(context, frame, "promo")])), env.opts.autoescape);
output += " class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__content-banner c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__content-banner";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"fontColorScheme")) {
output += "--";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"fontColorScheme"), env.opts.autoescape);
output += "-font";
;
}
output += "\" data-qa-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-live-text-banner>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"preHeadlineText")) {
output += "\n                    <span class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__pre-title\" data-qa-preheadline-text>\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"preHeadlineText"), env.opts.autoescape);
output += "\n                    </span>\n                ";
;
}
output += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"headlineText")) {
output += "\n                    <p class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__title\" data-qa-headline-text>\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"headlineText"), env.opts.autoescape);
output += "\n                    </p>\n                ";
;
}
output += "\n\n                <div class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__link-container\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"ctaLinks")) {
frame = frame.push();
var t_25 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"ctaLinks");
if(t_25) {var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("ctaLink", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
output += "\n                            <a\n                                ";
output += runtime.suppressValue((lineno = 74, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "gaCategory"),runtime.contextOrFrameLookup(context, frame, "gaAction"),runtime.memberLookup((runtime.memberLookup((t_26),"fields")),"linkTitle")])), env.opts.autoescape);
output += "\n                                href=\"";
output += runtime.suppressValue((lineno = 75, colno = 52, runtime.callWrap(t_8, "contentfulUrl", context, [runtime.memberLookup((runtime.memberLookup((t_26),"fields")),"linkPath")])), env.opts.autoescape);
output += "\"\n                                ";
if(runtime.memberLookup((runtime.memberLookup((t_26),"fields")),"openInNewWindow")) {
output += " target=\"_blank\" rel=\"noopener noreferrer\" ";
;
}
output += "\n                                class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__a\"\n                                data-qa-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-link";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
output += "\n                            >";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_26),"fields")),"linkTitle"), env.opts.autoescape);
output += "</a>\n\n                        ";
;
}
}
frame = frame.pop();
output += "\n\n                    ";
;
}
output += "\n\n                    ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"promoDesc") && runtime.contextOrFrameLookup(context, frame, "isHeader")) || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"promoDesc") && runtime.contextOrFrameLookup(context, frame, "isFooter") && (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_medium") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_small") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")))) {
output += "\n                        <a ";
output += runtime.suppressValue((lineno = 86, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "gaCategory"),runtime.contextOrFrameLookup(context, frame, "gaAction"),"promo details"])), env.opts.autoescape);
output += " href=\"#\" id=\"a-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-control\" class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__a c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__a--toggle js-promo-details-link\" aria-expanded=\"false\" aria-controls=\"a-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-target\" data-qa-details-link>\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"descriptionCtaVerbage")) {
output += "\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"descriptionCtaVerbage"), env.opts.autoescape);
output += "\n                            ";
;
}
else {
output += "\n                                ";
output += runtime.suppressValue((lineno = 90, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["global-promo-details"])), env.opts.autoescape);
output += "\n                            ";
;
}
output += "\n                        </a>\n                    ";
;
}
output += "\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n    ";
;
}
;
}
output += "\n\n    ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"promoDesc") && runtime.contextOrFrameLookup(context, frame, "isFooter")) && (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_large"))) {
output += "\n        <div id=\"a-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-hover\" class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__details c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__details";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"fontColorScheme")) {
output += "--";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"fontColorScheme"), env.opts.autoescape);
output += "-font";
;
}
output += "  c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__hover s-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo js-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-details-content\" aria-hidden=\"true\">\n            <div class=\"o-row\">\n                <div class=\"o-column o-extra-small--12\">\n                    <p>\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"promoDesc"), env.opts.autoescape);
output += "\n                    </p>\n                </div>\n            </div>\n        </div>\n    ";
;
}
output += "\n\n    </div>\n\n</div>\n\n";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"promoDesc") && runtime.contextOrFrameLookup(context, frame, "isHeader")) || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"promoDesc") && runtime.contextOrFrameLookup(context, frame, "isFooter") && (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_medium") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_small") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")))) {
output += "\n\n    <div ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"detailsBackgroundColor")) {
output += " style=\"background-color: #";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"detailsBackgroundColor"), env.opts.autoescape);
output += ";\" ";
;
}
output += " id=\"a-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-target\" class=\"s-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__details c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__details";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"fontColorScheme")) {
output += "--";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"fontColorScheme"), env.opts.autoescape);
output += "-font";
;
}
output += " js-promo-details-content\" aria-hidden=\"true\" aria-labelledby=\"a-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo-control\" data-qa-promo-description>\n        <div class=\"o-row\">\n            <div class=\"s-cms g-global-promo__details c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__details";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"fontColorScheme")) {
output += "--";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"fontColorScheme"), env.opts.autoescape);
output += "-font";
;
}
output += "\">\n                ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"promoDesc")), env.opts.autoescape);
output += "\n            </div>\n        </div>\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/global-promo.j2"] , dependencies)